import { useEffect, useState } from 'react';

const useMenuData = menu => {
  const [submenu, setSubmenu] = useState([]);

  useEffect(() => {
    const groupedMenuItems = menu.menuItem.reduce((result, item) => {
      const businessType = item.businessType;
      const group = item.group;

      if (!result[businessType]) {
        result[businessType] = {
          businessType,
          groups: [],
        };
      }

      const existingGroup = result[businessType].groups.find(g => g.group === group);

      if (!existingGroup) {
        result[businessType].groups.push({
          group,
          items: [item],
        });
      } else {
        existingGroup.items.push(item);
      }

      return result;
    }, {});

    const transformedData = Object.values(groupedMenuItems);

    setSubmenu(transformedData);
  }, [menu]);

  return submenu;
};

export default useMenuData;
